import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = {
  class: "card",
  style: {"max-width":"720px"}
}
const _hoisted_3 = {
  class: "grid",
  style: {"gap":"12px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("div", null, [
          _createElementVNode("h1", { class: "title" }, "Seguranca do trabalho"),
          _createElementVNode("p", { class: "subtitle" }, "Selecione o tipo de documento.")
        ]),
        _createElementVNode("span", { class: "pill" }, "Novo")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "item-card",
          type: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goDialogo && _ctx.goDialogo(...args)))
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("strong", null, "Dialogos de Seguranca", -1),
          _createElementVNode("div", { class: "item-meta" }, "Registro de dialogo com equipe.", -1)
        ]))]),
        _createElementVNode("button", {
          class: "item-card",
          type: "button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goPermissao && _ctx.goPermissao(...args)))
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("strong", null, "Permissao de Trabalho Critico", -1),
          _createElementVNode("div", { class: "item-meta" }, "Documento critico de seguranca.", -1)
        ]))]),
        _createElementVNode("button", {
          class: "item-card",
          type: "button",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goOcorrido && _ctx.goOcorrido(...args)))
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("strong", null, "Relatorio de Ocorrido", -1),
          _createElementVNode("div", { class: "item-meta" }, "Descreva um ocorrido e anexe imagens.", -1)
        ]))])
      ])
    ])
  ]))
}